import {IsoDate} from "../../../../../pseudo-types/DateTypes";
import {TmcTicket} from "../../types/OptionsTicket";
import {TmcLeg} from "./TmcRequests";
import {OrderAdvice} from "../../place-order-wizard/models/OrderAdvice";
import {OrderLifetime} from "../../../../../orders/models/OrderRecord";
import {Exchange} from "../../../../../instruments/exchange/Exchange";
import {Condition, PriceBase} from "../../../../../orders/models/OrderConditions";
import {ChildOrder} from "../../place-order-wizard/models/ChildOrder";
import {PricingInstruction} from "../../../../../orders/models/PricingInstruction";

export interface PlaceOrderRequest {
    readonly code: string;
    readonly exchange?: Exchange | null;
    readonly description: string;
    readonly buy: boolean;
    readonly quantity: number;
    readonly limit: number;
    readonly pricingInstruction: PricingInstruction;
    readonly lifetime?: OrderLifetime | null;
    readonly expires?: IsoDate | null;
    readonly legs: ReadonlyArray<PlaceOrderLeg>;
    readonly tmcOverride?: boolean;
    readonly advice?: OrderAdvice;
    readonly conditions?: OrderPlaceConditions | null;
    readonly isParentOrder: boolean | null;
    readonly childOrders: Array<ChildOrder>;
}

export interface PlaceOrderLeg {
    readonly code: string;
    readonly ratio: number;
}

export interface OrderPlaceConditions {
    readonly priceBase: PriceBase;
    readonly condition: Condition;
    readonly price: number;
    readonly expiry?: IsoDate | null;
}

/*
 * Because our types are getting even more messed up, so we copy only what we want from whatever
 * is currently on the object claiming to be a TmcTicket
 */
export function fromTmcTicket(ticket: TmcTicket): PlaceOrderRequest {
    const legs = ticket.legs.map(fromTmcLeg);
    return {
        code: ticket.code,
        description: ticket.description,
        buy: ticket.buy,
        quantity: ticket.quantity,
        limit: ticket.limit!,
        pricingInstruction: PricingInstruction.LIMIT,
        legs,
        isParentOrder: false,
        childOrders: []
    };
}

function fromTmcLeg(leg: TmcLeg): PlaceOrderLeg {
    return {
        code: leg.code,
        ratio: leg.ratio
    };
}
